import { FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { CustomUpgradeRiskBanner } from "../ScenarioDialog/CustomUpgradeRiskBanner";
import { ScenarioPreviewBanner } from "../ScenarioDialog/ScenarioPreviewBanner";
import { VisibilityInput } from "../VisibilityInput";
import css from "./SubmitScenarioFields.module.scss";
import {
    ScenarioBuilderAction,
    ScenarioBuilderState
} from "./useScenarioBuilderState";

interface SubmitScenarioFieldsProps {
    readonly action: ScenarioBuilderAction;
    readonly builder: ScenarioBuilderState;
}

export const SubmitScenarioFields: React.FC<SubmitScenarioFieldsProps> = ({
    action,
    builder
}: SubmitScenarioFieldsProps) => (
    <>
        <FormGroup label="Title" labelInfo="(required)">
            <InputGroup
                placeholder="Enter a title..."
                name="title"
                required
                autoFocus
                value={builder.title}
                onValueChange={builder.setTitle}
            />
        </FormGroup>
        <FormGroup
            label="Visibility"
            subLabel="Select where this scenario should be visible. You can change this later."
        >
            <VisibilityInput
                parentProject={builder.parentProject}
                setParentProject={builder.setParentProject}
                includedSpeculativeProjectIds={
                    builder.includedSpeculativeProjectIds
                }
            />
        </FormGroup>
        {action === "create" && (
            <FormGroup
                label="Run scenario"
                subLabel="If enabled, this scenario will be run immediately when you submit."
            >
                <Switch
                    label="Run this scenario now"
                    checked={builder.runOnSubmit}
                    onChange={() =>
                        builder.setRunOnSubmit(!builder.runOnSubmit)
                    }
                />
            </FormGroup>
        )}
        <div className={css["SubmitScenarioFields-banners"]}>
            <ScenarioPreviewBanner
                projectSizeAssumptionsMetadata={
                    builder.projectSizeAssumptionsMetadata
                }
                isWarningAcknowledged={builder.isWarningAcknowledged}
                setIsWarningAcknowledged={builder.setIsWarningAcknowledged}
            />
            <CustomUpgradeRiskBanner
                selectedUpgradeId={builder.selectedUpgradeId}
            />
        </div>
    </>
);
